// extracted by mini-css-extract-plugin
export default {"productGallery":"uK-z","inQuickShop":"vK-z"};